module.exports = __webpack_public_path__ + "img/lock-icon.be7724a2.svg";